import React, { useState } from 'react';
import { Box, Typography, Paper, TextField, Button, Grid, Avatar, Divider } from '@mui/material';
import { Person, Save, PhotoCamera } from '@mui/icons-material';

const ProfilePage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: 'João Silva',
    email: 'joao@empresa.com',
    phone: '(11) 98765-4321',
    position: 'Administrador',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Profile:', formData);
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        <Person sx={{ mr: 1, verticalAlign: 'middle' }} />
        Meu Perfil
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, textAlign: 'center' }}>
            <Avatar
              sx={{ width: 120, height: 120, mx: 'auto', mb: 2, fontSize: 48 }}
            >
              {formData.name.charAt(0)}
            </Avatar>
            <Typography variant="h6" fontWeight="bold">{formData.name}</Typography>
            <Typography color="text.secondary" gutterBottom>{formData.position}</Typography>
            <Button variant="outlined" startIcon={<PhotoCamera />} sx={{ mt: 2 }}>
              Alterar Foto
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 3 }}>
            <form onSubmit={handleSubmit}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
                Informações Pessoais
              </Typography>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome Completo"
                    value={formData.name}
                    onChange={handleChange('name')}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="E-mail"
                    type="email"
                    value={formData.email}
                    onChange={handleChange('email')}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Telefone"
                    value={formData.phone}
                    onChange={handleChange('phone')}
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 3 }} />

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
                Alterar Senha
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Senha Atual"
                    type="password"
                    value={formData.currentPassword}
                    onChange={handleChange('currentPassword')}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Nova Senha"
                    type="password"
                    value={formData.newPassword}
                    onChange={handleChange('newPassword')}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Confirmar Nova Senha"
                    type="password"
                    value={formData.confirmPassword}
                    onChange={handleChange('confirmPassword')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" startIcon={<Save />}>
                    Salvar Alterações
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfilePage;
